import React, { useEffect, useRef, useState } from 'react';
import {  Divider, Table, Popconfirm, Card, Tooltip, Switch,Input,Button,Tag,Row, Col, Drawer } from 'antd';
import {SupplierDTO} from '@gtpl/shared-models/masters';
import {SuppliersService} from '@gtpl/shared-services/masters';
import {CheckCircleOutlined,CloseCircleOutlined,RightSquareOutlined,EyeOutlined,EditOutlined,SearchOutlined } from '@ant-design/icons';
import Highlighter from 'react-highlight-words';
import { ColumnProps } from 'antd/lib/table';
import { AlertMessages } from '@gtpl/shared-utils/alert-messages';
import { SuppliersForm } from '@gtpl/pages/master/master-components/suppliers-form';
import { Link, Redirect } from 'react-router-dom';

import './suppliers-grid.css';
import moment from 'moment';
import { UserRequestDto } from '@gtpl/shared-models/common-models';

/* eslint-disable-next-line */
export interface SuppliersGridProps {}

export function SuppliersGrid(
  props:SuppliersGridProps
) {
  const searchInput = useRef(null);
  const [page, setPage] = React.useState(1);
  const [searchText, setSearchText] = useState(''); 
  const [searchedColumn, setSearchedColumn] = useState('');

  const [drawerVisible, setDrawerVisible] = useState(false);
  const [suppliersData, setSuppliersData] = useState<SupplierDTO[]>([]);
  const [selectedSuppliersData, setSelectedSuppliersData] = useState<any>(undefined);
  
  const suppliersService=new SuppliersService();

  useEffect(() => {
    getAllSuppliers();
  }, []);

  /**
   * 
   */
  const getAllSuppliers= () => {
    suppliersService.getAllSuppliers(new UserRequestDto(JSON.parse(localStorage.getItem('username')))).then(res => {
      if (res.status) {
        setSuppliersData(res.data);
      } else {
        if (res.intlCode) {
          setSuppliersData([]);
            AlertMessages.getErrorMessage(res.internalMessage);
        } else {
         AlertMessages.getErrorMessage(res.internalMessage);
        }
      }
    }).catch(err => {
      setSuppliersData([]);
      AlertMessages.getErrorMessage(err.message);
    })
  }
  /**
   * 
   * @param suppliersData 
   */
  const activateorDeactivateSupplier = (suppliersData:SupplierDTO) => {
    suppliersData.isActive=suppliersData.isActive?false:true;
    suppliersService.activateorDeactivateSupplier(suppliersData).then(res => { console.log(res);
      if (res.status) {
        getAllSuppliers();
        AlertMessages.getSuccessMessage('Success');
      } else {
        if (res.intlCode) {
          AlertMessages.getErrorMessage(res.internalMessage);
        } else {
          AlertMessages.getErrorMessage(res.internalMessage);
        }
      }
    }).catch(err => {
      AlertMessages.getErrorMessage(err.message);
    })
  }
   
    /**
     * 
     * @param supplierInfo 
     */
    const updateSupplier = (supplierInfo: SupplierDTO) => {
      suppliersService.updateSupplier(supplierInfo).then(res => { console.log(res);
        if (res.status) {
          AlertMessages.getSuccessMessage('Updated Successfully');
          getAllSuppliers();
          setDrawerVisible(false);
        } else {
          if (res.intlCode) {
            AlertMessages.getErrorMessage(res.internalMessage);
          } else {
            AlertMessages.getErrorMessage(res.internalMessage);
          }
        }
      }).catch(err => {
        AlertMessages.getErrorMessage(err.message);
      })
    }
   /**
   * used for column filter
   * @param dataIndex column data index
   */
  const getColumnSearchProps = (dataIndex:string) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={ searchInput }
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
          icon={<SearchOutlined />}
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}>
          Reset
        </Button>
      </div>
    ),
    filterIcon: filtered => (
      <SearchOutlined type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
    record[dataIndex]
    ? record[dataIndex]
       .toString()
        .toLowerCase()
        .includes(value.toLowerCase())
        : false,
    onFilterDropdownVisibleChange: visible => {
      if (visible) {    setTimeout(() => searchInput.current.select());   }
    },
    render: text =>
      text ?(
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text.toString()}
        />
      ) :text
      ) 
      
      : null
     
  });

  /**
   * 
   * @param selectedKeys 
   * @param confirm 
   * @param dataIndex 
   */
  function handleSearch(selectedKeys, confirm, dataIndex) {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  function handleReset(clearFilters) {
    clearFilters();
    setSearchText('');
  };

    //drawer related
    const closeDrawer=()=>{
      setSelectedSuppliersData(undefined);
      setDrawerVisible(false);
    }
  
    //TO open the form for updation
    const openFormWithData=(viewData: SupplierDTO)=>{
      
      setSelectedSuppliersData(undefined);
      setDrawerVisible(true);
      viewData.farmInfo.map((farm)=>{
        farm.expiryDate = moment(farm.expiryDate)
      })
      
      setSelectedSuppliersData(viewData);
    }


  const columnsSkelton: ColumnProps<any>[] = [
    {
      title: 'S No',
      key: 'sno',
      width: '70px',
      render: (text, object, index) => (page-1) * 10 +(index+1)
    },
    
    {
      title: 'Supplier Category',
      dataIndex: 'supplierCategory',
      // responsive: ['lg'],
      sorter: (a, b) => a.supplierCategory.localeCompare(b.supplierCategory),
      sortDirections: ['descend', 'ascend'],
      filters: [
        { text: 'Agent', value: 'Agent' },
        { text: 'Farmer', value: 'Farmer' },
        { text: 'Dealer', value: 'Dealer' },
      ],
      filterMultiple: false,
      onFilter: (value, record) => 
      {
        // === is not work
        return record.supplierCategory === value;
      },
    },
    {
      title: 'Farmer Code',
      dataIndex: 'supplierCode',
      // responsive: ['lg'],
      sorter: (a, b) => a.supplierCode.localeCompare(b.supplierCode),
      sortDirections: ['descend', 'ascend'],
      ...getColumnSearchProps('supplierCode')
    },
    {
      title: 'Farmer Name',
      dataIndex: 'supplierName',
      // responsive: ['lg'],
      sorter: (a, b) => a.supplierName.localeCompare(b.supplierName),
      sortDirections: ['descend', 'ascend'],
      ...getColumnSearchProps('supplierName')
    },
       {
      title: 'Pan Num',
      dataIndex: 'panNumber',
      // responsive: ['lg'],
      sorter: (a, b) => a.panNumber.localeCompare(b.panNumber),
      sortDirections: ['descend', 'ascend'],
      ...getColumnSearchProps('panNumber')
    },
    // {
    //   title: 'Remarks',
    //   dataIndex: 'remarks',
    //   // responsive: ['lg'],
    //   sorter: (a, b) => a.remarks.length - b.remarks.length,
    //   sortDirections: ['descend', 'ascend'],
    //   ...getColumnSearchProps('productName')
    // },
    {
      title: 'Status',
      dataIndex: 'isActive',
      render: (isActive, rowData) => (
        <>
          {isActive?<Tag icon={<CheckCircleOutlined />} color="#87d068">Active</Tag>:<Tag icon={<CloseCircleOutlined />} color="#f50">In Active</Tag>}
          
        </>
      ),
      filters: [
        {
          text: 'Active',
          value: true,
        },
        {
          text: 'InActive',
          value: false,
        },
      ],
      filterMultiple: false,
      onFilter: (value, record) => 
      {
        // === is not work
        return record.isActive === value;
      },
      
    },
    {
      title:`Action`,
      dataIndex: 'action',
      render: (text, rowData) => (
        <span>         
            <EditOutlined  className={'editSamplTypeIcon'}  type="edit" 
              onClick={() => {
                if (rowData.isActive) {
                  openFormWithData(rowData);
                } else {
                  AlertMessages.getErrorMessage('You Cannot Edit Deactivated Supplier');
                }
              }}
              style={{ color: '#1890ff', fontSize: '14px' }}
            />
          
          <Divider type="vertical" />
            <Popconfirm onConfirm={e =>{activateorDeactivateSupplier(rowData);}}
            title={
              rowData.isActive
                ? 'Are you sure to Deactivate Supplier ?'
                :  'Are you sure to Activate Supplier ?'
            }
          >
            <Switch  size="default"
                className={ rowData.isActive ? 'toggle-activated' : 'toggle-deactivated' }
                checkedChildren={<RightSquareOutlined type="check" />}
                unCheckedChildren={<RightSquareOutlined type="close" />}
                checked={rowData.isActive}
              />
            
          </Popconfirm>
        </span>
      )
    }
  ];

  /**
   * 
   * @param pagination 
   * @param filters 
   * @param sorter 
   * @param extra 
   */
  const onChange=(pagination, filters, sorter, extra)=> {
    console.log('params', pagination, filters, sorter, extra);
  }
  const OpenFormTocreateRecord = () => {
   console.log('redirect here');
   


  }
  return (
    <Card title={<span style={{color:'white'}}>Farmers</span>}
    style={{textAlign:'center'}} headStyle={{backgroundColor: '#69c0ff', border: 0 }} extra={<Link to='/suppliers-form' ><Button className='panel_button' >Create </Button></Link>}
    
    >
     <br></br>
     <Row gutter={40} >
      <Col>
          <Card title={'Total Farmers: ' + suppliersData.length} style={{textAlign: 'left', width: 250, height: 41,backgroundColor:'#bfbfbf'}}></Card>
          </Col>
          <Col>
           <Card title={'Active: ' + suppliersData.filter(el => el.isActive).length} style={{textAlign: 'left', width: 200, height: 41,backgroundColor:'#52c41a'}}></Card>
          </Col>
          <Col>
           <Card title={'In-Active: ' + suppliersData.filter(el => el.isActive == false).length} style={{textAlign: 'left', width: 200, height: 41,backgroundColor:'#f5222d'}}></Card>
          </Col>
          </Row>
          <br></br>
          <Table
          rowKey={record => record.supplierId}
          columns={columnsSkelton}
          dataSource={suppliersData}
          pagination={{
            onChange(current) {
              setPage(current);
            }
          }}
          onChange={onChange}
          bordered />
        <Drawer bodyStyle={{ paddingBottom: 80 }} title='Update' width={window.innerWidth > 768 ? '75%' : '85%'}
            onClose={closeDrawer} visible={drawerVisible} closable={true}>
            <Card headStyle={{ textAlign: 'center', fontWeight: 500, fontSize: 16 }} size='small'>
              <SuppliersForm 
                key={Date.now()}
                supplierData={selectedSuppliersData}
                updateSupplier= {updateSupplier}
                isUpdate= {true}
                closeForm= {closeDrawer}
                />
            </Card>
          </Drawer>
     </Card>
  );
}

export default SuppliersGrid;
